<script>
  import { scaleLinear, extent, descending, sum } from "d3";
  import viewport from "../stores/viewport.js";
  import Country from "./Rank.Country.svelte";
  import Axis from "./Rank.Axis.svelte";

  export let data;
  export let metric;

  const REM = 16;
  const ROW_HEIGHT = REM * 3;
  const MEDALS = sum(data, (d) => d.total);
  const PER = ["population", "gdp"];

  let dataRanked = [];

  $: hasNoIndex = PER.includes(metric);

  $: values = data.map((d) => {
    if (hasNoIndex) return d.total / d[metric];
    return d[metric];
  });

  $: total = sum(values);

  $: maxWidth = $viewport.width < 720 ? 90 : 95;

  $: dataMedals = data.map((d) => {
    let share = hasNoIndex ? d.total / d[metric] / total : d[metric] / total;
    const totalMedals = share * MEDALS;
    let metricGold = Math.round((d.gold / d.total) * totalMedals);
    let metricSilver = Math.round((d.silver / d.total) * totalMedals);
    let metricBronze = Math.round((d.bronze / d.total) * totalMedals);

    // hack minimum 1 bronzino
    let metricTotal = metricGold + metricSilver + metricBronze;
    metricBronze = metricTotal === 0 ? 1 : metricBronze;
    metricTotal = metricTotal === 0 ? 1 : metricTotal;

    return {
      ...d,
      metricGold,
      metricSilver,
      metricBronze,
      metricTotal,
    };
  });

  $: totalValues = dataMedals.map((d) => d.metricTotal);

  $: [min, max] = extent(totalValues);

  $: yScale = scaleLinear()
    .domain([0, data.length])
    .range([0, data.length * ROW_HEIGHT]);

  $: {
    const dupe = dataMedals.map((d) => ({ ...d }));
    dupe.sort(
      (a, b) =>
        descending(a.metricTotal, b.metricTotal) ||
        descending(a.metricGold, b.metricGold) ||
        descending(a.metricSilver, b.metricSilver) ||
        descending(a.metricBronze, b.metricBronze)
    );

    totalValues.sort(descending);

    dataRanked = dataMedals.map((d) => ({
      ...d,
      index: dupe.findIndex((u) => u.iso2 === d.iso2),
      rank: totalValues.indexOf(d.metricTotal) + 1,
      xGold: (d.metricGold / max) * maxWidth,
      xSilver: (d.metricSilver / max) * maxWidth,
      xBronze: (d.metricBronze / max) * maxWidth,
    }));
  }
</script>

<Axis min="{min}" max="{max}" />

<div class="container" style="height: {dataRanked.length * ROW_HEIGHT}px;">
  <div class="countries">
    {#each dataRanked as { name, iso2, ioc, index, rank, xGold, xSilver, xBronze, metricGold, metricSilver, metricBronze } (iso2)}
      <Country
        name="{name}"
        iso2="{iso2}"
        ioc="{ioc}"
        index="{index}"
        rank="{rank}"
        xGold="{xGold}"
        xSilver="{xSilver}"
        xBronze="{xBronze}"
        metricGold="{metricGold}"
        metricSilver="{metricSilver}"
        metricBronze="{metricBronze}"
        height="{ROW_HEIGHT}"
      />
    {/each}
  </div>
</div>

<style>
  .countries {
    position: relative;
  }
</style>
